module.exports = __webpack_public_path__ + "assets/uploading.svg";